import React from "react";
import { AdvancedMarker } from "@vis.gl/react-google-maps/dist/index.umd.js";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { useTranslations } from "adapters/i18n";

const DarkTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    slotProps={{
      popper: {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [-8, -8],
            },
          },
        ],
      },
    }}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(0, 0, 0,0.75)",
    padding: "12px 16px",
  },
}));

export const IconeFarol = (props) => {
  const {
    cor,
    valorExibido,
    posicaoIcone,
    handleSetPastoComColetaMorte,
    styles,
    icon,
  } = props;
  const label = obtemLabelIcone(valorExibido.toString(), cor);
  return RenderIcone(
    posicaoIcone,
    label,
    handleSetPastoComColetaMorte,
    styles,
    icon
  );
};

const RenderIcone = (
  position,
  label,
  handleSetPastoComColetaMorte,
  styles,
  icon
) => {

  const { t } = useTranslations();

  return (
    <AdvancedMarker
      position={position}
      key={position.lat}
      onClick={handleSetPastoComColetaMorte}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "50%",
          width: "30px",
          height: "30px",
          color: label.color,
          fontSize: "12px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...styles,
        }}
      >
        {!icon && label.text}
        {icon && (
          <DarkTooltip title={t("statusIndicator:unresolved-pasture-pendencies")}>
            <div
              style={{
                fontSize: "20px",
                color: "#FFC944",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {icon}
            </div>
          </DarkTooltip>
        )}
      </div>
    </AdvancedMarker>
  );
};
const obtemLabelIcone = (textoIcone, cor) => {
  return { text: textoIcone, color: cor, fontSize: "12px", fontWeight: "bold" };
};

export default IconeFarol;
